import { createSlice } from "@reduxjs/toolkit";
import { toast } from 'react-toastify';
import { Enums } from "../../../helper/constants/enums";
import { getAllInvoiceCommissionAction, generateInvoiceCommissionAction, updateInvoiceCommissionAction } from "../../actions/reportsAction/invoiceCommissionActions";

const INITIAL_STATE = {
    AllInvoiceCommissionData: {
        data: {
            records: [],
            totalRecords: 0,
        },
        apiMsg: {
            message: null,
            status: null,
            type: null,
        },
    },
    GenerateInvoiceCommissionData: {
        data: {},
        apiMsg: {
            message: null,
            status: null,
            type: null,
        },
    },
    UpdateInvoiceCommissionData: {
        data: {},
        apiMsg: {
            message: null,
            status: null,
            type: null,
        },
    },
}

const InvoiceCommissionReducer = createSlice({
    name: "InvoiceCommission",
    initialState: INITIAL_STATE,
    reducers: {

        RESET(state, action) {
            state = INITIAL_STATE;
        },

    },

    extraReducers: (builder) => {

        builder.addCase(getAllInvoiceCommissionAction.fulfilled, (state, action) => {
            state.AllInvoiceCommissionData.data = action.payload.data;
            state.AllInvoiceCommissionData.apiMsg.status = action.meta.requestStatus;
            state.AllInvoiceCommissionData.apiMsg.message = "success";
        });
        builder.addCase(getAllInvoiceCommissionAction.pending, (state, action) => {
            state.AllInvoiceCommissionData.apiMsg.status = action.meta.requestStatus;
        });
        builder.addCase(getAllInvoiceCommissionAction.rejected, (state, action) => {
            state.AllInvoiceCommissionData.apiMsg.message = action.error.message;
            state.AllInvoiceCommissionData.apiMsg.status = action.meta.requestStatus;
        });

        builder.addCase(updateInvoiceCommissionAction.fulfilled, (state, action) => {

            if (action.meta.arg) {

                const newData = action.meta.arg;
                const apiData = action.payload.data;
                const existingRecords = state.AllInvoiceCommissionData.data.records;

                const index = existingRecords ? existingRecords.findIndex(record => record.commissionInvoiceID === newData.commissionInvoiceID) : -1;

                if (index !== -1) {
                    existingRecords[index] = {
                        ...existingRecords[index],
                        // ...apiData,
                        invoiceStatus: apiData.invoiceStatus,
                        invoiceSendDate: apiData.invoiceSendDate,
                        invoicePaidDate: apiData.invoicePaidDate,
                        statusList: apiData.statusList

                    };
                }
                state.AllInvoiceCommissionData.data.records = existingRecords;
                state.UpdateInvoiceCommissionData.data = {
                    ...newData
                };
            }


            state.UpdateInvoiceCommissionData.apiMsg.status = action.meta.requestStatus;
            state.UpdateInvoiceCommissionData.apiMsg.message = action.payload.message.message;
            toast.success(action.payload.message.message, {
                position: "bottom-center",
                toastId: "success"
            });
        }
        );
        builder.addCase(updateInvoiceCommissionAction.pending, (state, action) => {
            state.UpdateInvoiceCommissionData.apiMsg.status = action.meta.requestStatus;
        }
        );
        builder.addCase(updateInvoiceCommissionAction.rejected, (state, action) => {

            state.UpdateInvoiceCommissionData.apiMsg.message = action.error.message;
            state.UpdateInvoiceCommissionData.apiMsg.status = action.meta.requestStatus;

            toast.error(action.error.message ? action.error.message : "Something went wrong please try again", {
                position: "bottom-center",
                toastId: "error"
            });
        }
        );

        builder.addCase(generateInvoiceCommissionAction.fulfilled, (state, action) => {
            state.GenerateInvoiceCommissionData.data = action.payload.data;
            state.GenerateInvoiceCommissionData.apiMsg.status = action.meta.requestStatus;
            state.GenerateInvoiceCommissionData.apiMsg.message = action.payload.message.message;
        });

        builder.addCase(generateInvoiceCommissionAction.pending, (state, action) => {
            state.GenerateInvoiceCommissionData.data = null;
            state.GenerateInvoiceCommissionData.apiMsg.message = action.meta.requestStatus;;
            state.GenerateInvoiceCommissionData.apiMsg.status = action.meta.requestStatus;
        });

        builder.addCase(generateInvoiceCommissionAction.rejected, (state, action) => {
            state.GenerateInvoiceCommissionData.apiMsg.message = action.error.message;
            state.GenerateInvoiceCommissionData.apiMsg.status = action.meta.requestStatus;
        });
    }
});

export const { RESET } = InvoiceCommissionReducer.actions;
export default InvoiceCommissionReducer.reducer;